import React from "react";
import { CircularProgress } from "@mui/material";

const Loading = () => {
  return <CircularProgress />;
};

export default Loading;
